import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'cleanNumber'})
export class CleanNumberPipe implements PipeTransform {

    transform(value:any) {
        if (value) {
          return value.toString().replace(",", "");
        }
    }
}
